import React, { useState } from 'react';
import { useLanguage } from '../i18n';

export default function LoginModal({ open, onClose, onSuccess, onSwitchToRegister }) {
  const { t, language } = useLanguage();
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    setError(''); // Clear error when user types
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await fetch('/api/auth/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        credentials: 'include',
        body: JSON.stringify(formData)
      });

      const data = await response.json();

      if (response.ok) {
        onSuccess(data.user);
        onClose();
        setFormData({ email: '', password: '' });
      } else {
        setError(data.error || t('loginFailed'));
      }
    } catch (err) {
      console.error('Login error:', err);
      setError(t('loginFailed'));
    } finally {
      setLoading(false);
    }
  };

  if (!open) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <h2>{t('loginTitle')}</h2>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>

        <form onSubmit={handleSubmit} className="auth-form">
          {error && (
            <div className="error-message">
              {error}
            </div>
          )}

          <div className="form-group">
            <label htmlFor="email">{t('email')} *</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              style={{ background: "#e9f5db" }}
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">{t('password')} *</label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
              style={{ background: "#e9f5db" }}
            />
          </div>

          <div className="form-actions">
            <button 
              type="submit" 
              disabled={loading || !formData.email || !formData.password}
              className="submit-button"
            >
              {loading ? t('loading') : t('loginButton')}
            </button>
          </div>

          <div className="auth-switch">
            <p>
              {t('dontHaveAccount')}{' '}
              <button 
                type="button" 
                className="link-button" 
                onClick={onSwitchToRegister}
              >
                {t('clickHereToRegister')}
              </button>
            </p>
          </div>
        </form>
      </div>
    </div>
  );
}